import { useStaticQuery, graphql } from "gatsby";
import { find, isArray, isEmpty, some } from "lodash";

import { useTranslationContext } from "~/context/TranslationContext";

const getCtaToUse = (priorityList, globalCtas) => {
    const globalCta = find(globalCtas, (globalCta) => globalCta);
    const fallback = globalCta?.ctaSections || [];
    const list = isArray(priorityList) ? priorityList : [];

    let ctaToUse = fallback;

    for (const slug of list) {
        const priorityCta = find(globalCtas, (globalCta) => {
            return some(globalCta?.productCategory, (productCategory) => {
                return slug && productCategory?.slug === slug;
            });
        });

        if (priorityCta) {
            const { ctaSections } = priorityCta;
            ctaToUse = ctaSections;
            break;
        }
    }

    return ctaToUse;
};

const getGlobalCtas = (allWpTranslatableOptions, activeCode) => {
    const options = allWpTranslatableOptions?.nodes;

    const enOptions = find(options, {
        languageCode: "en",
    });

    const trOptions = find(options, {
        languageCode: activeCode,
    });

    const english = enOptions?.translatableOptionFields?.globalCtas || [];
    const translation = trOptions?.translatableOptionFields?.globalCtas || [];

    return isEmpty(translation) ? english : translation;
};

const useGlobalCtas = (priorityList, ctaOverrides = null) => {
    const { allWpTranslatableOptions } = useStaticQuery(graphql`
        query GlobalCTAsStaticQuery {
            allWpTranslatableOptions {
                nodes {
                    languageCode
                    translatableOptionFields {
                        globalCtas {
                            productCategory {
                                slug
                            }
                            ctaSections {
                                title
                                links {
                                    type
                                    linkUrl
                                    linkLabel
                                    icon
                                    formId
                                    doc {
                                        ...DocumentFragment
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const { activeCode } = useTranslationContext();

    if (ctaOverrides) {
        return ctaOverrides;
    }

    const globalCtas = getGlobalCtas(allWpTranslatableOptions, activeCode);

    return getCtaToUse(priorityList, globalCtas);
};

export default useGlobalCtas;
